import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styles from '../Baccarat/styles.module.css';
import BollywoodCasinoimg from '../../../images/BollywoodCasino/bollywood casino.png';
import FooterLinks from '../FooterLinks';
import { useLocation } from 'react-router-dom';
import GameScreen from './GameScreen';
import  FlipClock from  "../../FlipClock/FlipClock"
import useCasinoBetplace from '../../../api/useCasinoBetplace';
import useRoundLoader from '../../../api/useRoundLoader';
import RoundLoader from '../../Loader/RoundLoader';

const positions = ['PLAYER_A', 'PLAYER_B', 'TIE'];

const playerAData = [
    { label: "Winner",      odds: "1.98", betType: "MAIN", selection: "PLAYER_A",   expKey: "playerAWins" },
    { label: "High Card",   odds: "1.98", betType: "SIDE", selection: "HIGH_CARD_A", expKey: "highCardA" },
    { label: "Pair",        odds: "3.25", betType: "SIDE", selection: "PAIR_A",      expKey: "pairA" },
];

const playerBData = [
    { label: "Winner",      odds: "1.98", betType: "MAIN", selection: "PLAYER_B",   expKey: "playerBWins" },
    { label: "High Card",   odds: "1.98", betType: "SIDE", selection: "HIGH_CARD_B", expKey: "highCardB" },
    { label: "Pair",        odds: "3.25", betType: "SIDE", selection: "PAIR_B",      expKey: "pairB" },
];

const tieData = [
    { label: "Tie", odds: "9.50", betType: "MAIN", selection: "TIE", expKey: "tieWins" }
];

function Baccarat({ onBetSelect, locked, socketData, settledData, gameId = 10,hookExposureData }) { // Added gameId prop (default 10 for Baccarat-like game)
    const [betDialogOpen, setBetDialogOpen] = useState(false);
    const [selectedBet, setSelectedBet] = useState(null);
      const roundId   = socketData?.roundId
    
    const remainingTime = socketData?.remainingTime;
       
    const [animTimer, setAnimTimer] = useState(null);
    const [exposureData, setExposureData] = useState(null);

    // Format betType for gameId 10 (or others)
    const formatBetType = (rawBetType) => {
        if (gameId !== 10) return rawBetType.toUpperCase(); // Default for other games
const betTypeMap = {
    'winner_a': 'WINNER_A',
    'winner_b': 'WINNER_B',
    'highcard_a': 'HIGHCARDA',
    'highcard_b': 'HIGHCARDB',
    'pair_a': 'PAIR_A',
    'pair_b': 'PAIR_B',
    'colour_a': 'COLOUR_A',
    'colour_b': 'COLOUR_B',
    'main': 'MAIN',  
};
        return betTypeMap[rawBetType.toLowerCase()] || rawBetType.toUpperCase();
    };

const handleNumberBoxClick = (item) => {
    if (!locked) {
        const betData = {
            label: item.label,
            odds: parseFloat(item.odds),
            betType: item.betType,   
            selection: item.selection, 
        };
        setSelectedBet(betData);
        setBetDialogOpen(true);
        if (onBetSelect) onBetSelect(betData);
    }
};


const getExposureValue = (key) => {
  if (!exposureData) return null;
  const val = exposureData[key];
  if (val === undefined || val === 0 || val === 0.00) return null;
  return val;
};
const ExposureLabel = ({ value }) => {
  if (value === null) return null;
  return (
    <Typography sx={{
      fontSize: '11px',
      fontWeight: 600,
      color: value < 0 ? '#ff4444' : '#1e6b0f',
      textAlign: 'center',
      width: '100%',
      mt: '2px',
      lineHeight: 1,
    }}>
      {value}
    </Typography>
  );
};
    const handleBetScreenClose = () => {
        setBetDialogOpen(false);
        setSelectedBet(null);
    };

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);
  useEffect(() => {
    if (hookExposureData === null) {
        setExposureData(null);
        return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
        setExposureData(hookExposureData);
    }
}, [hookExposureData, gameId]);

useEffect(() => {
  if (roundId) {
    setExposureData(null);
  }
}, [roundId]);


    return (
       
        <Box className={styles.MatchScreen_container}>
            <Box sx={{ position: 'relative', width: '100%' }}>
                <GameScreen
                    bettingClosed={socketData?.bettingClosed === true}
                    animationTime={typeof socketData?.animationTime === 'number' ? socketData.animationTime : undefined}
                    socketData={socketData}
                    settledData={settledData}
                    remainingTime={remainingTime}
                     onAnimStart={() => setAnimTimer(0)}
    onAnimEnd={() => setAnimTimer(null)}
                />
                <Box>
    <Box>
         <Box sx={{ position: 'absolute', bottom: '8px',    zIndex: 10,right: '8px' }}>
             <FlipClock
                 time={socketData?.bettingClosed ? 0 : (socketData?.remainingTime)}
             />
         </Box>
    </Box>
</Box>
            </Box>
            <Box className={styles.box}>
           
        
        {/* Player A */}
                <Box className={styles.PlayerABox}>
                    <Box>
                        <Typography className={styles.PlayerText}>Player A</Typography>
                    </Box>
                    <Box className={styles.GridBoxes}>
                        {playerAData.map((item, idx) => (
                            <Box
                                key={idx}
                                className={styles.GridContainer}
                                sx={{
                                    width: '100%',
                                    textAlign: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflow: 'visible',
                                }}
                            >
                                <Box className={styles.TextBox}>
                                    <Typography className={styles.Text}>{item.label}</Typography>
                                </Box>
                                <Box
                                    className={styles.BlueBox}
                              onClick={() => handleNumberBoxClick(item)}
                                    sx={{ cursor: locked ? 'not-allowed' : 'pointer', position: 'relative', marginBottom: '4px' }}>
                                    <Typography className={styles.NoText}>{item.odds}</Typography>
                                    
                                    {locked && (
                                        <Box className={styles.bettinglocked_icon_container}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                            </svg>
                                        </Box>
                                    )}
                                </Box>

                                   <ExposureLabel value={getExposureValue(item.expKey)} />
                            </Box>
                            
                        ))}
                     
                    </Box>
                    
                </Box>
             {/* Player B */}
                <Box className={styles.PlayerABox}>
                    <Box>
                        <Typography className={styles.PlayerText}>Player B</Typography>
                    </Box>
                    <Box className={styles.GridBoxes}>
                        {playerBData.map((item, idx) => (
                            <Box
                                key={idx}
                                className={styles.GridContainer}
                                sx={{
                                    width: '100%',
                                    textAlign: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflow: 'visible',
                                }}
                            >
                                <Box className={styles.TextBox}>
                                    <Typography className={styles.Text}>{item.label}</Typography>
                                </Box>
                                <Box
                                    className={styles.BlueBox}
                              onClick={() => handleNumberBoxClick(item)}
                                    sx={{ cursor: locked ? 'not-allowed' : 'pointer', position: 'relative', marginBottom: '4px' }}>
                                    <Typography className={styles.NoText}>{item.odds}</Typography>
                                   
                                    {locked && (
                                        <Box className={styles.bettinglocked_icon_container}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                <path d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z" fill="white" />
                                            </svg>
                                        </Box>
                                    )}
                                </Box>
                                 <ExposureLabel value={getExposureValue(item.expKey)} />
                            </Box>
                        ))}
                    </Box>
                </Box>
             
                                 <FooterLinks
                    socketData={socketData}
                    settledData={settledData}
                    gameType="Baccarat"
                />
            </Box>
        </Box>
    
    );
}

export default Baccarat;